import save from './save';
import deleteImage from './deleteImage';
import getGroupsWithRentals from './getGroupsWithRentals';
import createRentalGroup from './createRentalGroup';
import updateRentalGroup from './updateRentalGroup';
import deleteRentalGroup from './deleteRentalGroup';

export default {
  save,
  deleteImage,
  getGroupsWithRentals,
  createRentalGroup,
  updateRentalGroup,
  deleteRentalGroup,
};



// WEBPACK FOOTER //
// ./src/app/services/website/index.js